/** ************************************************************************
 * Atomic Component for the bPerx iFrame UI.
 *
 * Atomic Type: Content, static (content that never/rarely changes)
 * Purpose: Display the terms and conditions of the offer.
 *
 * @file   Atomic Component, content static, terms text
 * @author Paul J Stales
 * @since  2.5.0
 ************************************************************************ */

import { FunctionalComponent, h } from 'preact'
import { css } from 'aphrodite'
import { IFRAME_CLASSNAMES } from '../../../../../../common/constants/ConstantsIFrameClassNames'
import { TransactionInformation } from '../../../../../../common/types/transactionInformationTypes/TransactionInformation'

/**
 * Props Interface for OfferTermsText
 */
interface OfferTermsTextProps {
  styles: { [key: string]: any }
  areTermsVisible: boolean
  transactionInformation: TransactionInformation
}

/**
 * The single-line text explaining this is a gift.
 * @param OfferTermsTextProps
 * @returns
 */
const OfferTermsText: FunctionalComponent<OfferTermsTextProps> = ({
  styles,
  areTermsVisible,
  transactionInformation
}) => {
  return (
    <div
      class={`${IFRAME_CLASSNAMES.BPERX_SELECTED_OFFER_TERMS_TEXT}${' '}${
        styles[IFRAME_CLASSNAMES.BPERX_SELECTED_OFFER_TERMS_TEXT] === undefined
          ? ''
          : css(styles[IFRAME_CLASSNAMES.BPERX_SELECTED_OFFER_TERMS_TEXT])
      }${
        areTermsVisible
          ? ''
          : css(
              styles[
                IFRAME_CLASSNAMES.BPERX_SELECTED_OFFER_TERMS_TEXT_VISIBLE_FALSE
              ]
            )
      }`}
    >
      <h3>Offer Details - Terms and Conditions</h3>
      <br />
      {transactionInformation.customerChoice.productMagazineChosen.title} is a
      gift from us for being part of the program and based on your qualifying
      purchase. Valid while supplies last. You can cancel at any time. Gift code{' '}
      {transactionInformation.voucherInformation.voucherCode === undefined
        ? 'Generating voucher code...'
        : transactionInformation.voucherInformation.voucherCode}{' '}
      is good for one gift (unless otherwise noted) valued at $
      {transactionInformation.voucherInformation.voucherValueUSD}. This gift
      code expires 14 days after activation. The offer is valid in the United
      States (excluding the state of Minnesota) or Canada (if the offer
      recipient is in Canada). Limit one gift, per household, per year. All
      gifts are offered at the discretion of bPerx. For magazine gifts, you can
      choose to redeem the stated cash value instead. Go to
      http://www.bperx.com/ to submit your gift code and then click the "No
      Thanks, Take Me To Forms" link on the next page. Lost, stolen, damaged,
      expired or non-functioning gift codes will not be replaced or refunded.
      Gift codes are non-transferable. This gift may be withdrawn without
      notice. bPerx offers are valid for redemption by users 18 years of age and
      over. Any redemption by underage users is in direct violation of the bPerx
      Terms and Conditions, and in the event that bPerx discovers that any user
      redeeming a gift is under the age of 18, bPerx reserves the right to
      terminate any such gift at its sole discretion. Participating gifts are
      subject to change. If your gift selection is no longer available, bPerx
      reserves the right to replace it with another gift of similar content
      and/or value. We may transfer the information you provide to us to third
      party publishers who then redeem your gift subscription. Once the
      information is provided to those third parties, the subsequent use or
      disclosure of such information is subject to their privacy policies and
      practices. Please allow 8-16 weeks for non-digital gifts to deliver. Use
      of the gift code constitutes acceptance of all stated terms and
      conditions.
    </div>
  )
}

export default OfferTermsText
